import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import "../Styles.css";
import "../../../ui-styles/contentHeading/contentHeading.css";
import "../../../ui-styles/search/Search.css";
import "../../admin/reports/reports.css";
import "../../../ui-styles/nodata/NoData.css";
import "../../../ui-styles/inlineLink/inlineLinkIcon.css";
import { LangCtx, PayLoadCtx } from "../../../lib/context";
import "../../common/bookAppointment/BookAppointments.css";
import { getUsers } from "../../../actions/users";
import { Link } from "react-router-dom";
// import DropDownSm from "../../../lib/ui/dropdown/DropdownSm";
import Loader from "../../../lib/ui/loader/Loader";
import PatientsListItem from "./components/PatientsListItem";
import {API} from "aws-amplify";
// const drop = [{ label: "10", value: "10" }, { label: "50", value: "50" }, { label: "100", value: "100" }]


const PatientsList = (props) => {
    const { l } = useContext(LangCtx);
    const { payload } = useContext(PayLoadCtx);

    const firstRender = useRef(false)
    const [patients, setPatients] = useState([]);
    const [loading, setLoading] = useState(false);
    const [query, setQuery] = useState('');
    const [nextButton, setNextButton] = useState(false);
    const [prevButton, setprevButton] = useState(false);
    const [nextToken, setnextToken] = useState({});
    const [prevToken, setprevToken] = useState([]);
    const [display, setDisplay] = useState('');


    useEffect(() => {
        loadPatients();
        firstRender.current = true;
    }, []);

    useEffect(() => {
        if (display !== '') {
            firstRender.current = true;
            loadPatients();
        }
    }, [display]);

    const loadPatients = useCallback((token) => {
        setLoading(true);
        let _s = `&searchKey=${query}&clinicId=${payload.userId}`;
        getUsers('patient', _s, token, display).then(res => {
            setLoading(false);
            if (res && res.data.length > 0) {
                setPatients([...res.data]);
                if (res.token) {
                    setNextButton(true);
                    if (!firstRender.current) {
                        setprevButton(true);
                    }
                    setnextToken(res.token);
                }
                else {
                    if (!firstRender.current) {
                        setprevButton(true);
                    }
                    setNextButton(false);
                }
            } else {
                setNextButton(false);
            }
        }).catch(err => {
            if(API.isCancel(err)) {
                console.log("API is canceled................");
            } else {
                setLoading(false);
            }
            console.log("err in get patients === ", err);
            setPatients([])
        })
    },[query])

    useEffect(() => {
        if (query.length > 1 || query.length === 0) {
            loadPatients();
        }
    }, [query]);

    const handleNext = () => {
        prevToken.push(nextToken);
        setprevToken(prevToken);
        loadPatients(nextToken);
        firstRender.current = false;
    }

    const handlePrevious = () => {
        if (prevToken.length > 1) {
            setnextToken(prevToken[prevToken.length - 1]);
            prevToken.pop();
            setprevToken(prevToken);
            loadPatients(prevToken[prevToken.length - 1]);
            firstRender.current = false;
        }
        else {
            setprevToken([]);
            firstRender.current = true;
            loadPatients();
            setprevButton(false);
        }
    }

    return (
        <div className="baseContainer">
            <div className="hdngTopCol colBlock">
                <div className="hdngTopBox etcPdng">
                    <h2 className="topHdngTxt">{l.pat_list}</h2>
                </div>
                <div className="inlineItemContainer">
                    <div className="inlineItemGroup">
                        <Link className="inlineLink Sm" to="/create-patient"><span>{l.create_pat}</span></Link>
                    </div>
                </div>
            </div>
            <div className="searchCntnr">
                <div className="searchBox searchFull">
                    <div className="searchForm">
                        <input className="textbox" type="text" placeholder={l.plc_search}
                            value={query}
                            onChange={(e) => setQuery(e.target.value)} />
                    </div>
                </div>
            </div>
            <div className="rprtAtnRow flexWrap">
                <div className="halfRow makeFull">
                    {/* <span className="spanTxt">{l.show} {patients.length + '/' + display}</span> */}
                    <span className="spanTxt">{l.showing} 1 - 10 of 37 {l.entries}</span>
                    {/* <DropDownSm
                        placeholder="10"
                        items={drop}
                        value={display}
                        onChange={(e) => { setDisplay(e.target.value); }}
                        size="smallSize"
                    /> */}
                </div>
                <div className="halfRow">
                    <div className="prevNxtBox">
                        <div className="prevBtn" onClick={prevButton ? handlePrevious : () => false}>
                            <span className={prevButton ? "activeTxt active" : "activeTxt inactive"} >{l.previous}</span>
                        </div>
                        <div className="nxtBtn" onClick={nextButton ? handleNext : () => false}>
                            <span className={nextButton ? "activeTxt active" : "activeTxt inactive"} > {l.next}</span>
                        </div>
                    </div>
                </div>
            </div>
            <ul className="cntcListGroup">
                {loading ? <Loader /> : patients.map(patientItem => (
                    <PatientsListItem data={patientItem} key={patientItem.userId} reloadData={loadPatients} />
                ))
                }
            </ul>
        </div>
    )
}
export default PatientsList;